import { Stack, Text } from '@chakra-ui/react';
import type { PromoCode as PromoCodeType } from 'types/cart/PromoCode';

import { CopyPromoCodeButton } from './CopyPromoCodeButton';

interface PromoCodeProps {
  title: string;
  promoCode: PromoCodeType;
}

export function PromoCode({ promoCode, title }: PromoCodeProps) {
  return (
    <Stack spacing="3xs" width="100%">
      <Text
        className="promo-code-message"
        fontSize="sm"
        fontWeight="medium"
        color="green.600"
      >
        {promoCode.message}
      </Text>
      <CopyPromoCodeButton productTitle={title} code={promoCode.code} />
    </Stack>
  );
}
